import * as R from 'rambdax'
import {flatten} from 'tizra/functional'
import {nullish} from 'tizra/types'
import * as constants from './constants'
import {defaultTheme} from './theme'

/**
 * Convert full theme to CSS vars.
 */
export const themeVars = flatten({
  prefix: '--eg-theme-',
  joiner: '-',
  transformer: (k, v) => {
    if (typeof k === 'string' && /[\W_]/.test(k)) return
    if (nullish(v)) return
    return [[k, typeof v === 'object' ? v : `${v}`]]
  },
})

export const defaultThemeVars = themeVars({
  ...constants,
  ...R.omit(
    // TODO: Tease these out of theme since they don't vary by branding.
    ['baseFonts', 'fakeCovers', 'fonts', 'fontMap', 'fontWeights', 'scales'],
    defaultTheme,
  ),
})
